import { all } from '@redux-saga/core/effects'

import authenticationSaga from './Authentication.saga'
import dashboardSaga from './Dashboard.saga'

function* rootSaga(): any {
    yield all([...authenticationSaga, ...dashboardSaga])
}

export default rootSaga
